import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Alert, Button } from 'antd';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/// 捕获面板渲染期的异常（含 lazy chunk 加载失败），避免单个面板崩溃
/// 拖垮整个应用。PanelHost 以 key={panelId} 挂载本组件，切换面板时自动重置。
export class PanelErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('panel render error', error, info.componentStack);
  }

  reset = () => {
    this.setState({ error: null });
  };

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <Alert
          type="error"
          showIcon
          message="面板渲染出错"
          description={String(error.message ?? error)}
          action={
            <Button size="small" onClick={this.reset}>
              重试
            </Button>
          }
          style={{ margin: 16 }}
        />
      );
    }
    return this.props.children;
  }
}
